<template>
  <div class="sideService" ref="outerDom">
    <ul class="clearfix">
      <li class="siderService-qq">
        <a-popover placement="left">
          <template slot="content">
            <p>咨询热线：<span style="color:#0e8fa5">020-87622828</span></p>
            <div style="text-align: center;"><img src="img/ycl-service-code.jpg" height="120" width="120"/></div>
            <div style="text-align: center;">微信公众号在线客服</div>
          </template>
          <!-- <template slot="title">
          </template> -->
          <a href="javascript:void(0)">
            <span class="ss-block"><img src="img/siderService-qq.png"/></span>
            <p>客服</p>
          </a>
        </a-popover>
      </li>
      <li class="siderService-backtop" @click="handleBackTop" style="margin-top:10px">
        <span class="ss-block">
          <img src="img/siderService-backtop.png"/>
        </span>
        <p>回顶</p>
      </li>
    </ul>
</div>
</template>
<script>
export default {
  name: 'sideService',
  data() {
    return {
      scrollTop: 0, //默认距离顶部的距离
      isShow: false, //控制返回顶部按钮的显隐
      scrollTrigger: false, //默认初始值
    }
  },
  methods: {
    handleBackTop() {
      this.$emit('handleBackTop')
    },
  },
  computed: {
    companyName() {
      return window.urlConfig?.web?.companyName
    },
    reserved() {
      return window.urlConfig?.web?.reserved
    }
  }
}
</script>
<style scoped lang="less">
.sideService {
  width: 54px;
  position: fixed;
  right: 20px;
  top: 300px;
  z-index: 99;
}
.sideService .sideService-close {
  display: block;
  width: 27px;
  height: 37px;
  left: 50%;
  margin-left: -14px;
  top: -37px;
  position: absolute;
  cursor: pointer;
}
.sideService li {
  width: 52px;
  height: 48px;
  border: 1px solid #efefef;
  padding-top: 10px;
  background: #fff;
  position: relative;
  -webkit-box-sizing: content-box !important;
}
.sideService li.siderService-qq {
  height: 60px;
  background: #0e8fa5;
  border-color: #0e8fa5;
}
.sideService li.siderService-qq > a > p {
  color: #fff;
  margin-top: 6px;
  text-align: center;
}
.sideService li > p {
  text-align: center;
  margin: 0;
}
.sideService li.siderService-qq a {
  display: block;
  text-decoration: none;
}
.sideService li.siderService-qq:hover {
  background: #0e8fa5;
  border-color: #0e8fa5;
}
.sideService li .ss-block {
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}
.sideService li .ss-block img {
  display: block;
  width: 22px;
  height: 44px;
  position: relative;
}
.sideService li:hover .ss-block img {
  top: -22px;
}
.sideService li p {
  font-size: 13px;
  color: #666666;
  margin: 0;
}
.sideService li.siderService-backtop {
  margin-top: 20px;
  cursor: pointer;
}
.sideService li:hover > p {
  color: #fff;
}
.sideService li:hover {
  background: #0e8fa5;
  border-color: #0e8fa5;
}
.sideService li .box {
  display: none;
}
.sideService li.siderService-wx .box {
  position: absolute;
  top: -60px;
  right: 62px;
}
.sideService li.siderService-wx .box i {
  display: block;
  width: 6px;
  height: 10px;
  position: absolute;
  top: 80px;
  right: -5px;
  /* background: url("../img/service/sideService-jt.png") no-repeat center; */
}
.sideService li.siderService-wx .box dl {
  background: #fff;
  border: 1px solid #efefef;
  width: 151px;
  padding: 10px 0;
  float: left;
}
.sideService li.siderService-wx .box dl:first-child {
  border-left: 1px solid #efefef;
}
.sideService li.siderService-wx .box dt img {
  width: 96px;
  height: 96px;
  margin: 0 auto;
  display: block;
}
.sideService li.siderService-wx .box dt p {
  font-size: 13px;
  color: #999999;
  margin-top: 3px;
  text-align: center;
}
.sideService li.siderService-email .box {
  position: absolute;
  width: 260px;
  top: 0;
  left: -260px;
}
.sideService li.siderService-email .box i {
  display: block;
  width: 6px;
  height: 10px;
  position: absolute;
  top: 30px;
  right: 7px;
  /* background: url("../img/service/sideService-jt.png") no-repeat center; */
}
.sideService li.siderService-email .box dl {
  background: #fff;
  border: 1px solid #efefef;
  border-top: none;
  width: 248px;
  padding-top: 22px;
  padding-bottom: 20px;
}
.sideService li.siderService-email .box dl:first-child {
  border-top: 1px solid #efefef;
}
.sideService li.siderService-email .box dt {
  width: 22px;
  height: 32px;
  float: left;
  overflow: hidden;
  position: relative;
  margin-left: 13px;
}
.sideService li.siderService-email .box dt > img {
  user-select: none;
  padding-top: 6px;
}
.sideService li.siderService-email .box dd {
  float: left;
  margin-left: 10px;
}
.sideService li.siderService-email .box dd p {
  font-size: 13px;
  color: #999999;
  user-select: none;
}
.sideService li.siderService-email .box dd em {
  display: block;
  font-size: 18px;
  color: #0e8fa5;
  font-family: arial;
  margin-top: 2px;
}
.sideService li:hover .box {
  display: block;
}
.phoneColor {
  color: red;
}
</style>